import { useRef, useState } from 'react';
import {
  Container,
  ColorWheelBg,
  ColorWheelSvg,
  ColorWheelInner,
  Pointer,
  ColorWheelResult,
} from './styles';

const ColorWheel = ({ resultingColor, onColorChange }) => {
  const svgRef = useRef();
  const [mouseMoving, setMouseMoving] = useState(false);
  const [pointerTop, setPointerTop] = useState(64);
  const [pointerLeft, setPointerLeft] = useState(188);

  function angleFor(x, y) {
    return Math.atan(y / x);
  }

  function rtod(r) {
    return Math.round(r * (180 / Math.PI)) + 90;
  }

  function paddedHex(dec) {
    const hex1 = `00${dec.toString(16)}`;
    return hex1.slice(-2);
  }

  function atoc(a) {
    let red = 0;
    let green = 0;
    let blue = 0;

    const colorPC = 255 / 60;
    if (a >= 300 || a <= 60) red = 255;
    if (a >= 60 && a <= 180) green = 255;
    if (a >= 180 && a <= 300) blue = 255;
    if (a > 0 && a < 60) {
      green = Math.round(a * colorPC);
    }
    if (a > 60 && a < 120) {
      red = Math.round((120 - a) * colorPC);
    }
    if (a > 120 && a < 180) {
      blue = Math.round((a - 120) * colorPC);
    }
    if (a > 180 && a < 240) {
      green = Math.round((240 - a) * colorPC);
    }
    if (a > 240 && a < 300) {
      red = Math.round((a - 240) * colorPC);
    }
    if (a > 300 && a < 360) {
      blue = Math.round((360 - a) * colorPC);
    }
    const hexString = `#${paddedHex(red)}${paddedHex(green)}${paddedHex(blue)}`;
    return hexString.toUpperCase();
  }

  const onSVGSelect = (e) => {
    const x = e.nativeEvent?.offsetX - 36;
    const y = e.nativeEvent?.offsetY - 36;
    const a = 188;
    let angle = angleFor(x - a, y - a);
    if (x < a) {
      angle += Math.PI;
    }
    const angleInDegrees = rtod(angle);
    const color = atoc(angleInDegrees);

    const selectX = Math.cos(angle) * a * 0.68;
    const selectY = Math.sin(angle) * a * 0.68;

    setPointerTop(a + selectY);
    setPointerLeft(a + selectX);

    onColorChange(color);
  };

  const onSVGMouseDown = () => {
    setMouseMoving(true);
  };
  const onSVGMouseUp = () => {
    setMouseMoving(false);
  };

  return (
    <Container>
      <ColorWheelInner />
      <ColorWheelResult color={resultingColor} />
      <Pointer
        top={pointerTop}
        left={pointerLeft}
      />
      <ColorWheelSvg
        ref={svgRef}
        id="wheel"
        onClick={onSVGSelect}
        onMouseDown={onSVGMouseDown}
        onMouseUp={onSVGMouseUp}
        onMouseOut={onSVGMouseUp}
        onMouseMove={mouseMoving ? onSVGSelect : undefined}
        viewBox="-100 -100 600 600"
      >
        <g fillOpacity={0}>
          <path
            d="M 200 0
           A 200 200, 0, 0, 1, 373.2 100
           L 200 200
           Z"
          />
          <path
            d="M 200 0
           A 200 200, 0, 0, 1, 373.2 100
           L 200 200
           Z"
          />
          <path
            d="M 200 0
           A 200 200, 0, 0, 1, 373.2 100
           L 200 200
           Z"
          />
          <path
            d="M 200 0
           A 200 200, 0, 0, 1, 373.2 100
           L 200 200
           Z"
          />
          <path
            d="M 200 0
           A 200 200, 0, 0, 1, 373.2 100
           L 200 200
           Z"
          />
          <path
            d="M 200 0
           A 200 200, 0, 0, 1, 373.2 100
           L 200 200
           Z"
          />
        </g>
      </ColorWheelSvg>
      <ColorWheelBg />
    </Container>
  );
};

export default ColorWheel;
